import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import { HerdManagementSystem } from './hms.type';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/hms');

export const getHerdManagementSystem = actionCreator.async<{}, HerdManagementSystem[]>('GET_HERD_MANAGEMENT_SYSTEM');
export const createHerdManagementSystem = actionCreator.async<FormName, HerdManagementSystem>(
  'CREATE_HERD_MANAGEMENT_SYSTEM',
);
export const editHerdManagementSystem = actionCreator.async<{ id: number; formName: FormName }, any>(
  'EDIT_HERD_MANAGEMENT_SYSTEM',
);
export const deleteHerdManagementSystem = actionCreator.async<{ id: number; formName: FormName }, any>(
  'DELETE_HERD_MANAGEMENT_SYSTEM',
);
